"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GolfCartReportPage = exports.GolfCartReportPageActions = void 0;
var golfCartReportPageActions_1 = require("./golfCartReportPageActions");
exports.GolfCartReportPageActions = golfCartReportPageActions_1.default;
var golfCartReportPage_1 = require("./golfCartReportPage");
exports.GolfCartReportPage = golfCartReportPage_1.default;
